import {guardByRight} from "@/app/routes/guards/right-guard-factory";

export const guardAnalyticsNormatives = guardByRight('watch_analytics_normatives');
export const guardAnalyticsProtocols = guardByRight('watch_analytics_protocols');
